<template>
  <v-progress-circular :size="150" :width="5" color="primary" indeterminate></v-progress-circular>
</template>

<script>
export default {}
</script>
